module.exports = __webpack_public_path__ + "static/img/service-02.f1df685f.png";